export default __webpack_public_path__ + "static/media/passport-logo-clean.a737e88d.png";